<div class="system-connections-page container-fluid">
  <div class="row justify-content-between sticky-header">
    <div class="mat-h3">System Connections</div>
    @if(systemConnections.length > 0){
    <button mat-stroked-button (click)="$event.stopPropagation(); loadSystemConnections(true)"
      [disabled]="testAllDisabled" class="small-button">
      <span class="text">
        @if (loader.testAll) {
        Testing all...
        } @else {
        Test all
        }
      </span>
    </button>
    }
  </div>
  <div class="row separator-bottom">
    <div class="col-12">
      @if (systemConnections.length === 0 && !loader.initial && !loader.testAll) {
        <div class="no-data-container text-center py-5">
          <mat-icon class="no-data-icon">cloud_off</mat-icon>
          <h4 class="mt-3">No System Connections Available</h4>
          <p class="text-muted">Please try again later or refresh the page.</p>
        </div>
      }
      <div class="col-12">
        <div [ngClass]="{hidden: (systemConnections.length === 0 && !loader.initial && !loader.testAll), 'pb-3': true}">
        <table mat-table [dataSource]="loader.initial || loader.testAll ? shimmerPlaceholder : systemConnections" class="width-100 mb-2" matSort>
          <ng-container matColumnDef="icon">
            <th mat-header-cell *matHeaderCellDef class="column-width-0"></th>
            <td mat-cell *matCellDef="let connection" class="cell cell-padding">
              @if (!loader.initial && !loader.testAll) {
                @if (expandedElement === connection) {
                  <span class="mdi mdi-chevron-up"></span>
                }
                @if (expandedElement !== connection) {
                  <span class="mdi mdi-chevron-down"></span>
                }
              } @else {
                <div class="shimmer-content icon-shimmer"></div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Name</th>
            <td mat-cell *matCellDef="let connection" class="ellipsis td-width">
              @if (loader.initial || loader.testAll) {
                <div class="shimmer-content name-shimmer"></div>
              } @else {
                {{ connection.name }}
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let connection" class="ellipsis td-width">
              @if (loader.initial || loader.testAll) {
                <div class="shimmer-content status-shimmer"></div>
              } @else {
                @if (connection.status) {
                  <span [matTooltip]="connection.message" class="mdi mdi-check-circle-outline icon-margin icon-primary text-success"></span>
                }
                @if (!connection.status) {
                  <span [matTooltip]="connection.message" class="mdi mdi-cancel icon-margin text-danger"></span>
                }
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Actions</th>
            <td mat-cell *matCellDef="let connection">
              @if (loader.initial || loader.testAll) {
                <div class="shimmer-content actions-shimmer"></div>
              } @else {
                <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" class="action-buttons">
                  <button mat-stroked-button (click)="$event.stopPropagation(); testConnection(connection)"
                    [disabled]="isConnectionTesting(connection.name)"
                    [class.testing]="isConnectionTesting(connection.name)" class="small-button">
                    <span class="text">
                      @if (isConnectionTesting(connection.name)) {
                      Testing...
                      } @else {
                      Test
                      }
                    </span>
                  </button>
                </div>
              }
            </td>
          </ng-container>

          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let connection" [attr.colspan]="displayColumns.length">
              <div class="element-detail"
                [@detailExpand]="connection?.name == expandedElement?.name ? 'expanded' : 'collapsed'">
                @if (connection?.name === expandedElement?.name) {
                <div class="expanded-details-container p-3">
                  <div class="details-section">
                    <div class="details-content">
                      <div class="details-layout-container">
                        <div class="details-column">
                          <div class="section-group">
                            <div class="group-title mb-3">
                            <div class="d-flex">
                              <span class="mdi mdi-information-outline me-2"></span>
                              {{ connection.name }}'s connection details
                            </div>
                            <div class="d-flex justify-content-end">
                              <button mat-icon-button class="icon" 
                              *ngIf="!loadingDetails"
                              (click)="$event.stopPropagation(); handleDecryption(connection)"
                              [disabled]="loadingDetails"
                              [matTooltip]="isDecrypted ? 'Click to hide connection details' : 'Click to show connection details'">
                              <mat-icon>{{ isDecrypted ? 'visibility_off' : 'visibility' }}</mat-icon>
                          </button>
                            </div>
                            </div>
                            <div class="group-content">
                              @if (!connection.status) {
                                <p class="connection-detail-value"><strong>Error Message:</strong> {{ connection.message }}</p>
                              }
                                <div class="mt-3">
                                  <ul class="mt-2">
                                    @if (loadingDetails) {
                                      <custom-content-loader type="custom"></custom-content-loader>
                                    } @else {
                                      <li *ngFor="let detail of connection.details | keyvalue">
                                        <div class="connection-detail-value detail-line" >
                                          <strong class="text-capitalize">{{ detail.key }}:</strong>
                                          <br *ngIf="isDecrypted && getKeyValueArray(detail.value)"/>
                                          <span class="connection-detail-value-span">
                                            @if (isPasswordType(detail.value)) {
                                              @if (isDecrypted && isPasswordVisible(detail)) {
                                                {{ getDetailValue(detail.value) }} 
                                                <!-- TODO: Should we display the password in the input field? -->
                                              } @else {
                                                @if (isConnectionTesting(connection.name) || loader.decrypting) {
                                                  <div class="shimmer-content value-shimmer"></div>
                                                } @else {
                                                  ********
                                                }
                                              }
                                              @if (isDecrypted) {
                                                <div class="password-toggle-btn-container">
                                                  <button mat-icon-button class="icon password-toggle-btn" (click)="togglePasswordVisibility(detail, $event)">
                                                    <mat-icon>{{ isPasswordVisible(detail) ? 'visibility_off' : 'visibility' }}</mat-icon>
                                                  </button>
                                                </div>
                                              }
                                            } @else {
                                              @if (isConnectionTesting(connection.name) || loader.decrypting) {
                                                <div class="shimmer-content value-shimmer"></div>
                                              } @else {
                                                @if(isDecrypted){
                                                  <ng-container *ngIf="getKeyValueArray(detail.value) as detailValue">
                                                    <ul>
                                                      <li *ngFor="let item of detailValue">
                                                        <strong>{{ item.key }}:</strong> {{ item.value }}
                                                      </li>
                                                    </ul>
                                                  </ng-container>
                                                  <ng-container *ngIf="!getKeyValueArray(detail.value)">
                                                    {{ getDetailValue(detail.value) }}
                                                  </ng-container>
                                                } @else {
                                                  ********
                                                }
                                            }
                                          }
                                          </span>
                                        </div>
                                      </li>
                                    }
                                  </ul>
                                </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let connection; columns: displayColumns; when: isBaseRow" class="cursor-pointer"
            [class.expanded-row]="expandedElement?.name === connection.name" 
            (click)="!loader.initial && !loader.testAll && onRowClick(connection)">
          </tr>

          @if (!loader.initial && !loader.testAll) {
            <tr mat-row *matRowDef="let connection; columns: ['expandedDetail']; when: isDetailRow" class="detail-row"
              [class.expanded]="expandedElement?.name === connection.name"
              [style.display]="expandedElement?.name === connection.name ? 'table-row' : 'none'"
              [@detailExpand]="expandedElement?.name === connection.name ? 'expanded' : 'collapsed'">
            </tr>
          }
        </table>
      </div>
      </div>
    </div>
  </div>
</div>